import angular from 'angular';
import gmailModalDescription from './gmailModalDescription';
import './style.scss';

export default angular
  .module('components.gmailModalDescription', [])
  .component('gmailModalDescription', gmailModalDescription).name;
